import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BotService } from 'src/app/core/services/bot.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { DateFormatService } from 'src/app/core/services/date-format.service';
@Component({
  selector: 'globot-cards-records',
  templateUrl: './cards-records.component.html',
  styleUrls: ['./cards-records.component.scss'],
})
export class CardsRecordsComponent {
  @Input() records: any[] = [];
  @Input() isMobile: boolean = false;
  @Output() chatHistorySelected = new EventEmitter<any>();
  botId = '';
  selectedCard!: string;

  private readonly avatarColors = ['#6D5BE6', '#F59E0B', '#22C55E', '#EF4444', '#3B82F6', '#EC4899', '#14B8A6'];

  getInitials(name: string): string {
    if (!name) return '?';
    const cleaned = name.split(';')[0].trim();
    const parts = cleaned.split(' ').filter(p => p.length > 0);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return cleaned.substring(0, 2).toUpperCase();
  }

  getAvatarColor(name: string): string {
    if (!name) return this.avatarColors[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return this.avatarColors[Math.abs(hash) % this.avatarColors.length];
  }
  constructor(
    private botService: BotService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private ss: SpinnerService,
    private dateFormatService: DateFormatService
  ) {
    this.botId = this.aRoute.snapshot.paramMap.get('id') ?? '';
    const sections = this.router.routerState.snapshot.url.split('/');
    this.botId = sections[3];
  }

  getDateUtc(date: any) {
    return this.dateFormatService.formatRelativeDateUtc(date);
  }

  /**
   * GLOB-1887: la card muestra la fecha del último mensaje real. `updated_at` no sirve
   * porque cualquier escritura sobre la conversación (procesamiento CRM, marcado de
   * leído, backfills) lo empuja a "ahora", y las conversaciones antiguas terminaban
   * etiquetadas como "Hoy". Los fallbacks cubren la ventana de despliegue en que el
   * backend todavía no envía `last_message_at`.
   */
  getRecordDate(record: any): string {
    return this.getDateUtc(record.last_message_at || record.updated_at || record.created_at);
  }

  getFirstPart(sender_id: string): string {
    return sender_id ? sender_id.split(';')[0] : '';
  }

  getDisplayName(record: any): string {
    return record?.name || 'Anónimo';
  }

  getChannelIcon(channel: string): string {
    const map: Record<string, string> = {
      WEB: 'pi pi-globe',
      WHATSAPP: 'pi pi-whatsapp',
      INSTAGRAM: 'pi pi-instagram',
      MESSENGER: 'pi pi-facebook',
      FACEBOOK: 'pi pi-facebook',
      DISCORD: 'pi pi-discord',
      SLACK: 'pi pi-slack',
    };
    return map[(channel || '').toUpperCase()] ?? 'pi pi-comments';
  }

  getChannelColor(channel: string): string {
    const map: Record<string, string> = {
      WEB: '#3B82F6',
      WHATSAPP: '#22C55E',
      INSTAGRAM: '#EC4899',
      MESSENGER: '#0084FF',
      FACEBOOK: '#1877F2',
      DISCORD: '#5865F2',
      SLACK: '#E01E5A',
    };
    return map[(channel || '').toUpperCase()] ?? '#6D5BE6';
  }

  trackByCorrelationId(_index: number, record: any): string {
    return record.correlation_id;
  }

  /**
   * GLOB-1888: se emite siempre una lista — vacía si la conversación no tiene mensajes
   * o si la llamada falla — para que el detalle muestre su estado vacío y no una
   * pantalla en blanco.
   */
  getChatHistory = (record: any) => {
    this.selectedCard = record.correlation_id;
    this.botService.getChatHistory(this.botId, record.correlation_id).subscribe({
      next: (chatHistory) => {
        this.chatHistorySelected.emit({ record, chatHistory: chatHistory ?? [] });
      },
      error: () => {
        this.chatHistorySelected.emit({ record, chatHistory: [] });
      },
    });
  };
}
